import { createRouter, createWebHistory } from "vue-router";
import Navigation from "@/views/Navigation/index.vue";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "navigation",
			component: Navigation
		}
	]
});

export default router;
